import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const navItemBtnDefaultVariants = {}
const navItemBtnCompoundVariants = []

const navItemBtnSlotNames = [
  [
    "root",
    "nav-item-btn__root"
  ],
  [
    "section",
    "nav-item-btn__section"
  ],
  [
    "inner",
    "nav-item-btn__inner"
  ],
  [
    "iconWrapper",
    "nav-item-btn__iconWrapper"
  ]
]
const navItemBtnSlotFns = /* @__PURE__ */ navItemBtnSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, navItemBtnDefaultVariants, getSlotCompoundVariant(navItemBtnCompoundVariants, slotName))])

const navItemBtnFn = memo((props = {}) => {
  return Object.fromEntries(navItemBtnSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const navItemBtnVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...navItemBtnDefaultVariants, ...compact(variants) })

export const navItemBtn = /* @__PURE__ */ Object.assign(navItemBtnFn, {
  __recipe__: false,
  __name__: 'navItemBtn',
  raw: (props) => props,
  variantKeys: navItemBtnVariantKeys,
  variantMap: {
  "size": [
    "1",
    "2"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, navItemBtnVariantKeys)
  },
  getVariantProps
})